﻿import $ from "jquery";

window.$ = $;
window.jQuery = $;

let select2ReadyPromise = null;

export async function ensureSelect2Ready() {
    if ($.fn.select2) {
        return true;
    }

    if (!select2ReadyPromise) {
        select2ReadyPromise = import("select2/dist/js/select2.full")
            .then(module => {
                const select2Factory = module.default || module;

                if (typeof select2Factory === "function") {
                    try {
                        // Select2 UMD factory genelde bu imzayı bekler
                        select2Factory(window, $);
                    } catch (error1) {
                        try {
                            // Bazı buildlerde tek argümanla çalışır
                            select2Factory($);
                        } catch (error2) {
                            console.warn("Select2 factory could not be attached.", error1, error2);
                        }
                    }
                }

                if (!$.fn.select2) {
                    console.warn("Select2 loaded but $.fn.select2 is still missing.");
                    return false;
                }

                return true;
            })
            .catch(error => {
                console.warn("Select2 could not be loaded.", error);
                return false;
            });
    }

    return await select2ReadyPromise;
}

export async function initViwoSelects(root = document) {
    const ready = await ensureSelect2Ready();

    if (!ready) {
        return;
    }

    const $root = root === document ? $(document) : $(root);

    $root.find("select").each(function () {
        const $select = $(this);

        if ($select.is("[data-native-select]")) return;
        if ($select.data("select2")) return;

        initSingleSelect($select);
    });
}

function initSingleSelect($select) {
    const dropdownParent = findDropdownParent($select);

    const placeholder =
        $select.attr("placeholder") ||
        $select.attr("data-placeholder") ||
        "";

    const options = {
        width: "100%",
        placeholder,
        allowClear: $select.is("[data-allow-clear]"),
        minimumResultsForSearch: getMinimumSearch($select),
        dropdownParent
    };

    const dropdownClass = $select.attr("data-select2-dropdown-class");

    if (dropdownClass) {
        options.dropdownCssClass = dropdownClass;
    }

    if ($select.attr("data-qr-select2-template") === "content-type") {
        options.templateResult = formatQrContentTypeOption;
        options.templateSelection = formatQrContentTypeSelection;
        options.escapeMarkup = markup => markup;
    }

    $select.select2(options);
    decorateSelect2Container($select);
}

function formatQrContentTypeOption(item) {
    if (!item.id) return item.text;

    const option = item.element;
    const icon = option?.dataset?.icon || "fa-regular fa-qrcode";
    const group = option?.dataset?.group || "";
    const description = option?.dataset?.description || "";

    return `
        <div class="qr-type-select-option">
            <span class="qr-type-select-option__icon">
                <i class="${escapeAttr(icon)}"></i>
            </span>

            <span class="qr-type-select-option__content">
                <strong>${escapeHtml(item.text)}</strong>
                ${description ? `<small>${escapeHtml(description)}</small>` : ""}
            </span>

            ${group ? `<span class="qr-type-select-option__group">${escapeHtml(group)}</span>` : ""}
        </div>
    `;
}

function formatQrContentTypeSelection(item) {
    if (!item.id) return item.text;

    const option = item.element;
    const icon = option?.dataset?.icon || "fa-regular fa-qrcode";
    const description = option?.dataset?.description || "";

    return `
        <div class="qr-type-select-selection">
            <span class="qr-type-select-selection__icon">
                <i class="${escapeAttr(icon)}"></i>
            </span>

            <span class="qr-type-select-selection__content">
                <strong>${escapeHtml(item.text)}</strong>
                ${description ? `<small>${escapeHtml(description)}</small>` : ""}
            </span>
        </div>
    `;
}

function escapeHtml(value = "") {
    return String(value)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
}

function escapeAttr(value = "") {
    return escapeHtml(value);
}

export async function refreshViwoSelects(root = document) {
    const ready = await ensureSelect2Ready();

    if (!ready) {
        return;
    }

    const $root = root === document ? $(document) : $(root);

    $root.find("select").each(function () {
        const $select = $(this);

        if ($select.is("[data-native-select]")) return;

        if ($select.data("select2")) {
            $select.select2("destroy");
        }
    });

    await initViwoSelects(root);
}

function getMinimumSearch($select) {
    const value = $select.attr("data-minimum-results-for-search");

    if (value !== undefined && value !== "") {
        const parsed = Number(value);

        if (parsed < 0) return Infinity;

        return Number.isNaN(parsed) ? Infinity : parsed;
    }

    const optionCount = $select.find("option").length;

    return optionCount > 8 ? 0 : Infinity;
}

function findDropdownParent($select) {
    const modal = $select.closest(".modal, .image-preview-modal, .language-drawer__panel");

    if (modal.length) {
        return modal;
    }

    return $("body");
}

window.addEventListener("viwo:accordion-opened", (event) => {
    const item = event.detail?.item;

    if (!item) return;

    setTimeout(() => {
        void refreshViwoSelects(item);
    }, 30);
});

function decorateSelect2Container($select) {
    const container = $select.next(".select2-container");

    if (!container.length) return;

    const select = $select.get(0);
    const containerEl = container.get(0);

    copySelectClassesToContainer(select, containerEl);
    copySelectDataAttributesToContainer(select, containerEl);

    const extraClass = $select.attr("data-select2-container-class");

    if (extraClass) {
        container.addClass(extraClass);
    }

    const variant = $select.attr("data-select2-variant") || $select.attr("data-variant");

    if (variant) {
        container.attr("data-select2-variant", variant);
    }
}

function copySelectClassesToContainer(select, container) {
    const classAttr = select.getAttribute("class");

    if (!classAttr) return;

    const ignoredClasses = new Set([
        "select2-hidden-accessible"
    ]);

    classAttr
        .split(/\s+/)
        .map(x => x.trim())
        .filter(Boolean)
        .filter(x => !ignoredClasses.has(x))
        .forEach(className => {
            container.classList.add(className);
        });
}

function copySelectDataAttributesToContainer(select, container) {
    Array.from(select.attributes).forEach(attr => {
        if (!attr.name.startsWith("data-")) return;

        // Select2 internal attribute. Bunu kopyalamayalım.
        if (attr.name === "data-select2-id") return;

        container.setAttribute(attr.name, attr.value);
    });
}